/* Acumen homepage configurator — swaps the stage photo when a wax finish or leg style is picked.
   Photos: one per leg × finish (Shopify Files, configure-{leg}-{finish}.jpg). A missing combination
   keeps that leg's photo in another finish and the finish tag names what is actually shown. */
(function () {
  var CDN = 'https://cdn.shopify.com/s/files/1/0017/0695/0720/files/';
  var LEGS = {
    'x-frame':   { name: 'blencathra', url: '/products/blencathra-industrial-dining-table-x-frame-leg' },
    'v-frame':   { name: 'grasmoor',   url: '/products/grasmoor-rustic-dining-table-v-frame-leg' },
    'spider':    { name: 'grisedale',  url: '/products/grisedale-rustic-dining-table-spider-leg' },
    'trapezium': { name: 'glenridding', url: '/products/industrial-box-leg-table-table-b' },
    'square':    { name: 'helvellyn',  url: '/products/industrial-box-section-leg-table-table-d' }
  };
  var FINISHES = { clear: 'clear', lime: 'lime', grey: 'grey wash', forest: 'forest brown', antique: 'antique oak', rugger: 'rugger brown', jacobean: 'jacobean' };
  var MISSING = {};
  /* Reclaimed elm mode (section setting): product-gallery room shots, bottom label cropped off. A leg × finish with no photo falls back as above. */
  var ELM_ON = false;
  var ELM = {"x-frame": {"lime": "5_826998f3-2efd-4b28-a850-8ee9496ae8d3.jpg", "jacobean": "2_5643911c-b897-435e-8d72-e5a4cc91d165.jpg", "rugger": "8_91c60fa6-c904-4d6a-bea0-98f443b1db21.jpg", "forest": "10_632319a9-d472-4b57-9185-caadcfb3ba0e.jpg", "antique": "6_a4bc7644-db4c-4286-89a9-9947e2b33b22.jpg", "clear": "configure-elm-x-frame-clear.jpg", "grey": "configure-elm-x-frame-grey.jpg"}, "v-frame": {"lime": "GrasmoorReclaimedElm.jpg", "antique": "1_bc7c1805-808b-4afc-8434-66d3a86be769.jpg", "rugger": "2_141122ce-ae7b-4d06-873b-9e00714886d9.jpg", "forest": "configure-elm-v-frame-forest.jpg", "jacobean": "configure-elm-v-frame-jacobean.jpg", "grey": "configure-elm-v-frame-grey.jpg", "clear": "configure-elm-v-frame-clear.jpg"}, "spider": {"clear": "GrisedaleElmProductImages.png", "grey": "3_86a06d84-623e-46bf-9e71-1ccb7993bcba.png", "rugger": "4_675d0295-d799-40ed-ad6b-071b7f0928fa.png", "antique": "6_d805f726-8fa8-4bdb-a168-f5e88457db0f.png", "jacobean": "1_0cd7ec4f-238c-4850-a37c-0e36007c11ca.png", "lime": "configure-elm-spider-lime.jpg", "forest": "configure-elm-spider-forest.jpg"}, "trapezium": {"clear": "GlenriddingElmproductpics.jpg", "lime": "6_c01f827b-1c2c-4a76-9e88-538b940463f1.jpg", "antique": "3_8f674213-1879-43b9-b5f1-7b1d16e08e42.jpg", "rugger": "4_4a27e200-cf5c-4d44-9ef3-55e237cf730c.jpg", "grey": "configure-elm-trapezium-grey.jpg", "forest": "configure-elm-trapezium-forest.jpg", "jacobean": "configure-elm-trapezium-jacobean.jpg"}, "square": {"forest": "8_bcceb798-6dd6-4960-ab24-749e124a9339.jpg", "antique": "1_6bf7179e-7174-4aef-abd6-5ff27a9bc7c0.jpg", "grey": "2_17fe77cd-449e-40a7-b780-a4968196202a.jpg", "clear": "3_9b8043f6-46ae-424f-91ce-d6163f2b0465.jpg", "rugger": "4_8163cf32-8942-4b2a-b4d4-77b0f5f7d98e.jpg", "jacobean": "5_d9f2ca11-90dd-4b5b-a17e-c8aef76ea26d.jpg", "lime": "configure-elm-square-lime.jpg"}};
  var ELM_LEGS = {
    'x-frame':   { name: 'blencathra', url: '/products/blencathra-reclaimed-elm-dining-table-x-frame-leg' },
    'v-frame':   { name: 'grasmoor',   url: '/products/grasmoor-reclaimed-elm-dining-table-v-frame-leg' },
    'spider':    { name: 'grisedale',  url: '/products/grisedale-reclaimed-elm-dining-table-spider-leg' },
    'trapezium': { name: 'glenridding', url: '/products/glenridding-reclaimed-elm-dining-table-trapezoid-leg' },
    'square':    { name: 'helvellyn',  url: '/products/helvellyn-reclaimed-elm-dining-table-square-legs' }
  };
  var FALLBACK_ORDER = ['antique', 'clear', 'forest', 'rugger', 'lime', 'jacobean', 'grey'];

  function finishSlug(name) {
    var n = (name || '').toLowerCase();
    if (n.indexOf('clear') > -1) return 'clear';
    if (n.indexOf('lime') > -1) return 'lime';
    if (n.indexOf('grey') > -1) return 'grey';
    if (n.indexOf('forest') > -1) return 'forest';
    if (n.indexOf('antique') > -1) return 'antique';
    if (n.indexOf('rugger') > -1) return 'rugger';
    if (n.indexOf('jacobean') > -1) return 'jacobean';
    return null;
  }
  function legSlug(name) {
    var n = (name || '').toLowerCase();
    if (n.indexOf('x') === 0) return 'x-frame';
    if (n.indexOf('v') === 0) return 'v-frame';
    if (n.indexOf('spider') > -1) return 'spider';
    if (n.indexOf('trap') > -1 || n.indexOf('trestle') > -1) return 'trapezium';
    if (n.indexOf('square') > -1) return 'square';
    return null;
  }
  function has(leg, fin) { return ELM_ON ? !!(ELM[leg] && ELM[leg][fin]) : !MISSING[leg + '-' + fin]; }
  function src(leg, fin, w) {
    if (ELM_ON) return CDN + ELM[leg][fin] + '?width=' + w + '&height=' + Math.round(w * 0.9) + '&crop=top';
    return CDN + 'configure-' + leg + '-' + fin + '.jpg?width=' + w;
  }

  function init(root) {
    ELM_ON = root.getAttribute('data-cf-timber') === 'elm';
    var L = ELM_ON ? ELM_LEGS : LEGS;
    var stage = root.querySelector('.cf-stage');
    var img = stage && stage.querySelector('img');
    if (!stage || !img) return;
    var tagFinish = root.querySelector('.cf-a1 .tick');
    var tagFell = root.querySelector('.cf-fell');
    var cta = root.querySelector('.cf-body a.cf-btn.solid');
    var sws = root.querySelectorAll('.cf-sw');
    var legs = root.querySelectorAll('.cf-leg');

    var state = {
      finish: finishSlug(tagFinish && tagFinish.textContent) || 'antique',
      leg: 'v-frame'
    };
    if (tagFell) {
      var fell = tagFell.textContent.toLowerCase();
      for (var k in L) if (fell.indexOf(L[k].name) > -1) state.leg = k;
    }

    var style = document.createElement('style');
    style.textContent =
      '[data-acumen-configure] .cf-sw,[data-acumen-configure] .cf-leg{cursor:pointer;transition:box-shadow .15s,border-color .15s}' +
      '[data-acumen-configure] .cf-sw.is-on{box-shadow:0 0 0 2px #fff,0 0 0 4px #2f3a24}' +
      '[data-acumen-configure] .cf-leg.is-on{border-color:#2f3a24;box-shadow:0 0 0 1px #2f3a24;background:#fff}' +
      '[data-acumen-configure] .cf-sw:focus-visible,[data-acumen-configure] .cf-leg:focus-visible{outline:2px solid #b08a4f;outline-offset:3px}' +
      '[data-acumen-configure] .cf-stage img{transition:opacity .25s ease}' +
      '[data-acumen-configure] .cf-stage img.is-fading{opacity:.35}';
    document.head.appendChild(style);

    function mark() {
      sws.forEach(function (el) {
        var on = finishSlug(el.getAttribute('title')) === state.finish;
        el.classList.toggle('is-on', on); el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      legs.forEach(function (el) {
        var on = legSlug(el.getAttribute('title')) === state.leg;
        el.classList.toggle('is-on', on); el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function render() {
      var shown = state.finish;
      if (!has(state.leg, shown)) {
        for (var i = 0; i < FALLBACK_ORDER.length; i++) if (has(state.leg, FALLBACK_ORDER[i])) { shown = FALLBACK_ORDER[i]; break; }
      }
      var s1 = src(state.leg, shown, 800), s2 = src(state.leg, shown, 1200), s3 = src(state.leg, shown, 1600);
      var pre = new Image();
      img.classList.add('is-fading');
      pre.onload = pre.onerror = function () {
        img.removeAttribute('srcset'); img.removeAttribute('sizes');
        img.setAttribute('srcset', s1 + ' 800w, ' + s2 + ' 1200w, ' + s3 + ' 1600w');
        img.setAttribute('sizes', '(min-width: 990px) 50vw, 100vw');
        img.src = s2;
        img.alt = (ELM_ON ? 'Reclaimed elm' : 'Rustic pine') + ' dining table with ' + state.leg.replace('-', ' ') + ' legs in ' + FINISHES[shown] + ' wax';
        img.classList.remove('is-fading');
      };
      pre.src = s2;
      if (tagFinish) tagFinish.textContent = FINISHES[shown];
      if (tagFell) tagFell.innerHTML = '◦ &nbsp;' + L[state.leg].name;
      if (cta && root.getAttribute('data-cf-touched')) cta.setAttribute('href', L[state.leg].url);
      mark();
    }

    function wire(list, key, slugFn) {
      list.forEach(function (el) {
        var slug = slugFn(el.getAttribute('title'));
        if (!slug) return;
        if (el.tagName === 'SPAN') { el.setAttribute('role', 'button'); el.setAttribute('tabindex', '0'); }
        function pick(e) {
          if (e) e.preventDefault();
          state[key] = slug; root.setAttribute('data-cf-touched', '1'); render();
        }
        el.addEventListener('click', pick);
        el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') pick(e); });
      });
    }
    wire(sws, 'finish', finishSlug);
    wire(legs, 'leg', legSlug);
    mark();

    // warm the cache for the current leg so finish clicks feel instant
    setTimeout(function () {
      Object.keys(FINISHES).forEach(function (f) { if (has(state.leg, f)) { var p = new Image(); p.src = src(state.leg, f, 1200); } });
    }, 2500);
  }

  function boot() { document.querySelectorAll('[data-acumen-configure]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
